import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('initVisitationReportsForm');

    $('.nested-fields').each(function () {
      attachListeners($(this));
    });

    function attachListeners(element: JQuery) {
      element.find('.clockpicker').clockpicker();
      element.find('.startClock').on('change', function () {
        const start_input = $(this).closest('.nested-fields').find('.visitation_report_start_s').find('input');
        const was = start_input.val() as any;
        start_input.val(getSeconds($(this)));
        const end_input = $(this).closest('.nested-fields').find('.visitation_report_end_s').find('input');
        const diff = (end_input.val() as any) - was;
        const end_val = Math.min(getSeconds($(this)) + diff, 86340);
        end_input.val(end_val);
        $(this).closest('.nested-fields').find('.endClock').val(getClock(end_val));
      });

      element.find('.endClock').on('change', function () {
        $(this).closest('.nested-fields').find('.visitation_report_end_s').find('input').val(getSeconds($(this)));
      });

      //element.find('.duration-Xm').click(function() {
      //	start_input = $(this).closest('.nested-fields').find('.visitation_report_start_s>input');
      //	end_val = Math.min(parseInt(start_input.val()) + (parseInt($(this).text()) * 60), 86340);
      //	$(this).closest('.nested-fields').find('.visitation_report_end_s>input').val(end_val);
      //	$(this).closest('.nested-fields').find('.endClock').val(getClock(end_val));
      //});
    }

    function getSeconds(input: JQuery) {
      const input_str = input.val() as string;
      const arr = input_str.split(':');
      let h = (arr.length > 0 && !isNaN(parseInt(arr[0]))) ? parseInt(arr[0]) : 8;
      let m = (arr.length > 1 && !isNaN(parseInt(arr[1]))) ? parseInt(arr[1]) : 0;
      h = h % 24;
      m = m % 60;
      const sec = h * 60 * 60 + m * 60;
      input.val(getClock(sec));
      return sec;
    }

    function getClock(sec: number) {
      return ('0' + Math.floor(sec / 3600)).slice(-2) + ':' + ('0' + (Math.floor(sec / 60) % 60)).slice(-2);
    }

    //$('#visitation_report_succeeded').change(refresh);
    //refresh();
    //function refresh() {
    //	$('#visitation_report_succeeded').is(":checked") ? $('#details').show(300) : $('#details').hide(300);
    //}

  }
}